import { useEffect } from "react"
import { useLocation, matchPath } from "react-router"
import { Link as RouterLink } from "react-router-dom"
import { useSelector } from "react-redux"
import PerfectScrollbar from "react-perfect-scrollbar"
import Logo from "components/Logo"
import NavItem from "./NavItem"
import { Avatar, Box, Divider, Drawer, Hidden, List, ListSubheader, Typography, Link } from "@mui/material"
import {
  AddBox,
  ViewList,
  LabelImportant,
  SwapHoriz, // Icon for Transferencias
} from "@mui/icons-material"
import formatter from 'helpers/formatter';
const country: any = formatter.getCountry();


const navConfig = (user: any) => {
  return [
    {
      subheader: "Reportes",
      items: [
        {
          title: "Transacciones",
          icon: ViewList,
          href: "/transactions2",
          redirect: true, // despues cambiar a false
        },
        {
          title: "Crear Transacción",
          icon: AddBox,
          href: "/vehicles/new",
          redirect: false,
          hide: !user.permissions.includes("negotiation_creation"),
        },
      ],
    },
    {
      subheader: "Otros",
      items: [
        {
          title: "Reportería",
          icon: LabelImportant,
          href: "/reporteria/",
          redirect: false,
          hide: !user.permissions.includes("show_bi_section"),
        },
        {
          title: "Informes",
          icon: LabelImportant,
          href: "/reports",
          redirect: false,
          hide: !user.permissions.includes("access_to_reports"),
        },
        {
          title: "Transferencias",
          icon: SwapHoriz,
          href: "https://autosafe.cl/empresas",
          redirect: true,
          hide: !['rebuyer_administrator', 'rebuyer', 'evaluation_supervisor_rebuyer'].includes(user.role) || country !== 'cl',
          badge: "¡Nuevo!",
        },
      ],
    },
  ]
}

function renderNavItems({ items, ...rest }: any) {
  return (
    <List disablePadding>{items.reduce((acc: any, item: any) => reduceChildRoutes({ acc, item, ...rest }), [])}</List>
  )
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }: any) {
  const key = item.title + depth

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    })

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
        redirect={item.redirect}
        hide={item.hide}
        badge={item.badge}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>,
    )
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
        redirect={item.redirect}
        hide={item.hide}
        badge={item.badge}
      />,
    )
  }

  return acc
}

const styles = {
  mobileDrawer: {
    width: 256,
    zIndex: 5000,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}

function NavBar({ openMobile, onMobileClose }: any) {
  const location = useLocation()
  const { user } = useSelector((state: any) => state.account)

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose()
    }
    // eslint-disable-next-line
  }, [location.pathname])

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden /*lgUp*/>
          <Box p={1} display="flex" justifyContent="center">
            <Link href="/">
              <Logo />
            </Link>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="#">
              <Avatar alt="User" sx={styles.avatar} src={user.avatar} />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link component={RouterLink} to="#" variant="h5" color="textPrimary" underline="none">
              {`${user.firstName} ${user.lastName}`}
            </Link>
            <Typography variant="body2" color="textSecondary">
              {user.company?.name}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {navConfig(user)?.map((config) => (
            <List
              key={config.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {config.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: config.items,
                pathname: location.pathname,
              })}
            </List>
          ))}
        </Box>
        <Divider />
      </PerfectScrollbar>
    </Box>
  )

  return (
    <>
      <Hidden /*lgUp*/>
        <Drawer anchor="left" sx={styles.mobileDrawer} onClose={onMobileClose} open={openMobile} variant="temporary">
          {content}
        </Drawer>
      </Hidden>
    </>
  )
}

export default NavBar